import { render, staticRenderFns } from "./InvoiceOptionsButton.vue?vue&type=template&id=8f874340&"
import script from "./InvoiceOptionsButton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOptionsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports